import styled from "@emotion/styled";
import { Col, Empty, Radio, Row } from "antd";
import type { RadioChangeEvent } from "antd";
import { FC, useEffect, useState } from "react";
import type { FactoryParcelAddressLookupItem } from "services/factoryParcelApi";
import ParcelDestinationAddressCard from "./ParcelDestinationAddressCard";

type ParcelDestinationAddressListProps = {
  items: FactoryParcelAddressLookupItem[];
  radioSelect: string;
  onRadioChange: (addressId: string) => void;
  /** ข้อความเมื่อไม่มีรายการ — ตาม AddressCardList ในระบบสั่งซื้อ */
  emptyDescription?: string;
};

/** รายการที่อยู่แบบ Radio.Group — ตาม AddressCardList ในระบบสั่งซื้อ */
const ParcelDestinationAddressList: FC<ParcelDestinationAddressListProps> = ({
  items,
  radioSelect,
  onRadioChange,
  emptyDescription = "ไม่มีที่อยู่ กรุณาสร้างที่อยู่จัดส่ง",
}) => {
  const [value, setValue] = useState<string>(radioSelect);

  useEffect(() => {
    setValue(radioSelect);
  }, [radioSelect]);

  const onChange = (e: RadioChangeEvent) => {
    const next = String(e.target.value ?? "");
    setValue(next);
    onRadioChange(next);
  };

  return (
    <WrapperAll>
      <StyledRadioGroup name="parcel-destination-address" onChange={onChange} value={value}>
        <Row style={{ overflow: "auto", padding: "5px" }}>
          {items.length > 0 ? (
            items.map((item) => (
              <ParcelDestinationAddressCard
                key={item.address_id}
                item={item}
                onSelect={onRadioChange}
              />
            ))
          ) : (
            <Col span={24}>
              <NotFoundWrapper>
                <Empty
                  description={emptyDescription}
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
              </NotFoundWrapper>
            </Col>
          )}
        </Row>
      </StyledRadioGroup>
    </WrapperAll>
  );
};

export default ParcelDestinationAddressList;

const StyledRadioGroup = styled(Radio.Group)`
  border: none;
  margin: 0;
  display: block;
  width: 100%;
`;

const WrapperAll = styled.div`
  padding: 10px 0;
`;

const NotFoundWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  flex-direction: column;
  width: 100%;
  padding: 24px 0;
`;
